const persistedJobsFilterParameters = new Set([
  'keywords',
  'sectors',
  'office_type',
  'job_type',
  'daily_rate_min',
  'daily_rate_max',
  'annual_salary_min',
  'annual_salary_max',
]);

const clearedJobsFilterParameters = new Set([
  ...persistedJobsFilterParameters,
  'locations',
  'location',
  'distance',
  'contract_type',
  'salary_min_day',
  'salary_max_day',
  'salary_min_annum',
  'salary_max_annum',
  'salary_type',
  'salary_min',
  'salary_max',
  'internal',
  'page',
]);

function canonicalJobsFilterParameter(parameter) {
  return parameter.replace(/\[\d*\]$/, '');
}

function setJobsPath(url, targetUrl) {
  const target = new URL(targetUrl, url);
  url.pathname = target.pathname;

  return url;
}

export function clearJobsFilterQueryParameters(url) {
  Array.from(url.searchParams.keys()).forEach((parameter) => {
    if (clearedJobsFilterParameters.has(canonicalJobsFilterParameter(parameter))) {
      url.searchParams.delete(parameter);
    }
  });

  return url;
}

export function appendJobsSectionFilterQueryParameters(url, filters) {
  Object.entries(filters).forEach(([parameter, rawValues]) => {
    if (!persistedJobsFilterParameters.has(parameter)) return;

    const values = (Array.isArray(rawValues) ? rawValues : [rawValues])
      .map((value) => String(value).trim())
      .filter(Boolean);

    if (!values.length) return;

    if (values.length === 1) {
      url.searchParams.append(parameter, values[0]);
      return;
    }

    values.forEach((value) => {
      url.searchParams.append(`${parameter}[]`, value);
    });
  });

  return url;
}

export function replaceJobsFilterQueryParameters(url, entries) {
  clearJobsFilterQueryParameters(url);

  const filters = {};

  for (const [rawParameter, rawValue] of entries) {
    const parameter = canonicalJobsFilterParameter(rawParameter);

    if (!persistedJobsFilterParameters.has(parameter)) continue;

    filters[parameter] ??= [];
    filters[parameter].push(rawValue);
  }

  return appendJobsSectionFilterQueryParameters(url, filters);
}

export function clearJobsFilterUrl(url, jobsIndexUrl) {
  setJobsPath(url, jobsIndexUrl);

  return clearJobsFilterQueryParameters(url);
}

export function replaceJobsFilterUrl(url, entries, jobsIndexUrl, sectorUrls) {
  const normalizedEntries = Array.from(entries);
  const sectorValues = normalizedEntries
    .filter(
      ([name, value]) =>
        canonicalJobsFilterParameter(name) === 'sectors' && String(value).trim() !== ''
    )
    .map(([, value]) => String(value).trim());
  const singleSectorUrl =
    sectorValues.length === 1 ? sectorUrls.get(sectorValues[0]) : null;

  setJobsPath(url, singleSectorUrl || jobsIndexUrl);

  const queryEntries = singleSectorUrl
    ? normalizedEntries.filter(
        ([name]) => canonicalJobsFilterParameter(name) !== 'sectors'
      )
    : normalizedEntries;

  return replaceJobsFilterQueryParameters(url, queryEntries);
}
